import { Config } from "../landing-config";
import { ico_pink } from "../map-config";


const maxFileRows = 500;
export const HOUSING_CONFIG: Config = {
    data: {
        route: 'housing',
        page_title: 'Housing | Open Fiber',
        service_title: 'Housing',
        service_description: '',
        service_name: '',
        service_slug: 'housing',
        errorTimeout: 10000,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '',
                massiveUploadPath: '',
                massiveDownloadPath: '',
                massiveP2pSalesforcePath: '',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/point/serviziohousing/p2p',
            bboxPath: null,
            buildingSearchParams: {
				service_platform: "HOUSING"
			}
        },
        dynamic_aend_name: 'HOUSING'
    },
    multiple_points: {
        variable: false,
        max: 1,
        points: {
            b_end: {
                default_method: 'pop',
                switch_methods: true,
                address: false,
                pop: true,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: false,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_building: false,
                city_pop: false,
                city_poi: false,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            },
            a_end: null
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: true,
        marker_default_icon: ico_pink,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: true,
    },
    area_types: ['CoveredAB','CoveredCD', 'CoveredAGF'],
    area_types_short: null, // TODO encode
    kml: false,
    pop: {
        load: true,
        view_initial: true,
        click: true,
        loadCities: true
    },
    pop_ola: {
        load: true,
        view_initial: true,
        click: true
    },
    pcn: {
        load: true,
        view_initial: true,
        click: true
    },
    pop_agf: {
        load: true,
        view_initial: true,
        click: true
    },
    poi: {
        load: true,
        view_initial: true,
        click: true,
        x_pop: true,
        is_registered: true,
        custom_research_method: 'Address',
        loadCities: true
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: false,
        click: false,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: true,
        types: {
            POP: {
                load: true,
                click: true,
            },
            XPOP: {
                load: true,
                click: true,
            }
        }
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}
